import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '@shoelace-style/shoelace/dist/components/card/card'
import '@shoelace-style/shoelace/dist/components/input/input'
import '@shoelace-style/shoelace/dist/components/tag/tag'

@customElement('vxc-input-tags')
export class TInputTags extends LitElement {

    static styles = css`
        :host {
            display: block;
            width: 100%;
            height: 100%;
            --border-radius: 5px;
            --sl-input-label-font-size-medium: .7rem;
            --sl-input-focus-ring-color: black;
            --sl-focus-ring-style: solid;
            --sl-focus-ring-width: 1px;
            --sl-input-border-width: 1px;
            --sl-input-focus-ring: var(--sl-focus-ring-style) var(--sl-focus-ring-width) var(--sl-input-focus-ring-color);
            --sl-input-focus-ring-offset: 0px;
        }

         sl-card {
            margin: 0px;
            padding: 0px;
            width: 100%;
            height: 100%;
        }

        sl-input {
            margin-top: 1rem;
        }

        .title {
            font-weight: 600;
            font-size: .7rem;
        }

        .description {
            font-weight: 400;
            font-size: .7rem;
        }

        sl-card::part(base) {
            height: 100%;
            width: 100%;
        }

        sl-card.no-border::part(base) {
            border: none;
            box-shadow: none;
        }

        #values {
            margin-top: 1rem;
        }
        
        sl-tag {
            margin-bottom: 2px;
        }

        sl-input {
            margin-top: 0;
            padding-top: 0;
        }


    `
    @property({ type: Boolean                 }) border = false
    @property({ type: String                  }) title = ''
    @property({ type: String                  }) description = 'Give a friendly identifier to your application.'
    @property({ type: String                  }) label = ''
    @property({ type: String                  }) name = 'input'
    @property({ type: String                  }) type = 'text'
    @property({ type: String                  }) size = 'medium'
    @property({ type: String                  }) tagSize = 'small'
    @property({ type: Array                   }) value: Array<string> = []
    @property({ type: String                  }) placeholder = ''
    @property({ type: String                  }) helptext = ''
    @property({ type: String                  }) pattern = ''
    @property({ type: Number                  }) minlength?: number
    @property({ type: Number                  }) maxlength?: number
    @property({ type: Number                  }) min?: number
    @property({ type: Number                  }) max?: number
    @property({ type: String                  }) autocorrect: string = 'off'
    @property({ type: Boolean                 }) spellcheck: boolean = false
    @property({ type: String                  }) inputmode: string = 'text'       // 'none' | 'text' | 'decimal' | 'numeric' | 'tel' | 'search' | 'email' | 'url'
    @property({ type: Boolean, reflect: true  }) clearable: boolean = false
    @property({ type: Boolean, reflect: true  }) noSpinButtons: boolean = false
    @property({ type: Boolean, reflect: true  }) passwordToggle: boolean = false
    @property({ type: Boolean, reflect: true  }) disabled: boolean = false
    @property({ type: Boolean, reflect: true  }) readonly: boolean = false
    @property({ type: Boolean, reflect: true  }) required: boolean = false   

    private gotInput(event: KeyboardEvent) {
        const slInput = event.target as any
        if(event.key === 'Enter') {
            const value = slInput.value 
            if(value.length)
                this.value = [...this.value, value]
            console.log('got value', value)
            slInput.value = ''
        }
    }

    private delValue(event: Event) {
        const slTag = event.target as any 
        const value = slTag.innerText
        console.log('remove', value)
        this.value = this.value.filter( val => val !== value )
    }

    render() {
        console.log('values', this.value)
        return html`
        <sl-card class=${this.border ? '' : 'no-border'}>
            <div class="title">${this.title}</div>
            <div class="description">${this.description}</div>
            <sl-input 
                id="input"
                name=${this.name} 
                label=${this.label}
                size=${this.size}
                ${this.pattern? html`minlength=${this.pattern}` : ''}
                ${this.minlength? html`minlength=${this.minlength}` : ''}
                ${this.maxlength? html`minlength=${this.maxlength}` : ''}
                ${this.min? html`minlength=${this.min}` : ''}
                ${this.max? html`minlength=${this.max}` : ''}
                autocorrect=${this.autocorrect}
                spellcheck=${this.spellcheck}
                inputmode=${this.inputmode}
                placeholder=${this.placeholder} 
                ?helpText=${this.helptext}
                @keydown=${this.gotInput}
            >
            </sl-input>
            <div id="values">
                ${this.value?.map( val => html`<sl-tag size="${this.tagSize}" @sl-remove=${this.delValue} removable>${val}</sl-tag><br/>`) }
            </div>    
        </sl-card>

        `
    }
}


declare global {
  interface HTMLElementTagNameMap {
    'vxc-input-tags': TInputTags
  }
}